import type { IUIState } from 'types';

const initialState: IUIState = {
  successModal: {
    isOpen: false,
    description: '',
    source: '',
    driveLink: '',
    analyticsData: {},
  },
  isShowCloseModal: false,
  isOpenedFromCloseModal: false,
  previewImage: undefined,
  gridDensity: 'medium',
};

export default initialState;
